module.exports = __webpack_public_path__ + "fonts/OpenSans800.0875122a.eot";